'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 60.68h84.888V.166H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                transform: 'translate(3)',
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('path', {
                d: 'M72.26 61a34.341 34.341 0 0 0 4.29-16.666c0-19.007-15.356-34.415-34.298-34.415-18.943 0-34.299 15.408-34.299 34.415 0 6.047 1.56 11.728 4.29 16.666H72.26z',
                fill: '#F7F7F8'
            }),
            _react2.default.createElement('ellipse', {
                fill: '#A7F2EB',
                cx: '20.257',
                cy: '53.474',
                rx: '1.986',
                ry: '1.981'
            }),
            _react2.default.createElement('ellipse', {
                fill: '#A7F2EB',
                cx: '64.743',
                cy: '53.474',
                rx: '1.986',
                ry: '1.981'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                d: 'M41.257 5.455h1.492V0h-1.492zM31.491 6.943l-1.17-5.047 1.316-.408 1.17 5.047zM23.49 10.91l-2.613-4.646 1.364-.809 2.613 4.647zM15.75 16.862l-3.82-3.811 1.15-1.149 3.82 3.812zM10.125 24.797L5.468 22.19l.81-1.362 4.658 2.607zM6.053 33.228L.994 32.06l.408-1.312 5.06 1.167zM83.1 53.561l-5.06-1.167.409-1.313 5.06 1.167zM0 43.146h5.468V41.66H0zM79.532 43.146H85V41.66h-5.468zM1.403 53.561l-.409-1.313 5.06-1.167.408 1.313zM78.45 33.228l-.41-1.313 5.06-1.167.409 1.312zM74.875 24.797l-.81-1.36 4.657-2.608.81 1.362zM69.25 16.862l-1.15-1.148 3.82-3.812 1.15 1.149zM62.007 10.91l-1.364-.808 2.613-4.647 1.364.809zM52.514 6.943L51.2 6.535l1.17-5.047 1.315.408z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M26.518 35.897l16.23-13.58 16.499 13.58.402 23.12H25.848l.402-22.657z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                d: 'M24.854 59.512h1.491V35.707h-1.491zM58.158 59.512h1.491V35.707h-1.491zM29.39 51.506h9.32v-7.793h-9.32v7.793zm-1.554 1.559h12.427v-10.91H27.836v10.91zM44.24 57.528h12.427V42.154H44.24z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M45.793 55.91h9.32V43.773h-9.32z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                d: 'M63.087 39.675L42.75 22.88 22.41 39.675l-1.037-1.195L42.75 20.83l21.374 17.65z'
            }),
            _react2.default.createElement('ellipse', {
                fill: '#A7F2EB',
                cx: '42.5',
                cy: '34.61',
                rx: '3.469',
                ry: '3.461'
            }),
            _react2.default.createElement('path', {
                d: 'M42.444 31.215a3.183 3.183 0 0 0-3.185 3.174 3.184 3.184 0 0 0 3.185 3.174 3.184 3.184 0 0 0 3.185-3.174 3.183 3.183 0 0 0-3.185-3.174m0 7.942c-2.638 0-4.784-2.14-4.784-4.768 0-2.628 2.146-4.767 4.784-4.767 2.639 0 4.784 2.139 4.784 4.767 0 2.629-2.145 4.768-4.784 4.768',
                fill: '#3F5060'
            }),
            _react2.default.createElement(
                'mask',
                {
                    id: 'b',
                    fill: '#fff'
                },
                _react2.default.createElement('use', {
                    xlinkHref: '#a'
                })
            ),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M41.645 38.36h1.6v-7.942h-1.6z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M38.46 35.186h7.97v-1.593h-7.97zM33.217 52.713h1.599v-9.56h-1.6z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M28.853 48.498h11.193v-1.594H28.853zM52.038 51.12h1.6v-1.594h-1.6zM56.835 34.638h1.6V23.235h-1.6zM52.038 29.21H50.44v-5.974h4.797v1.593h-3.198zM16.861 60.68h51.167v-1.594H16.861z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M19.26 59.883h1.599v-3.984h-1.6z'
            }),
            _react2.default.createElement('path', {
                d: 'M20.059 51.916c-.882 0-1.6.714-1.6 1.593s.718 1.593 1.6 1.593c.882 0 1.599-.714 1.599-1.593s-.717-1.593-1.6-1.593m0 4.78a3.196 3.196 0 0 1-3.197-3.187 3.196 3.196 0 0 1 3.198-3.187 3.196 3.196 0 0 1 3.198 3.187 3.196 3.196 0 0 1-3.198 3.187M64.03 59.883h1.6v-3.984h-1.6z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M64.83 51.916c-.882 0-1.6.714-1.6 1.593s.718 1.593 1.6 1.593c.882 0 1.599-.714 1.599-1.593s-.717-1.593-1.6-1.593m0 4.78a3.196 3.196 0 0 1-3.197-3.187 3.196 3.196 0 0 1 3.198-3.187 3.196 3.196 0 0 1 3.198 3.187 3.196 3.196 0 0 1-3.198 3.187',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#00D8C8',
                mask: 'url(#b)',
                d: 'M18.46 33.593h3.198V32H18.46zM23.257 33.593h1.599V32h-1.599zM60.033 28.813h3.198V27.22h-3.198zM64.83 28.813h1.6V27.22h-1.6z'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '90',
    height: '60',
    viewBox: '0 0 90 60',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var InboxIcon = function (_React$Component) {
    _inherits(InboxIcon, _React$Component);

    function InboxIcon() {
        _classCallCheck(this, InboxIcon);

        return _possibleConstructorReturn(this, (InboxIcon.__proto__ || Object.getPrototypeOf(InboxIcon)).apply(this, arguments));
    }

    _createClass(InboxIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return InboxIcon;
}(_react2.default.Component);

exports.default = InboxIcon;